import { createApp } from 'vue';
import { createAgonI18n } from '../../i18n';
import PrintWithStyles from './PrintWithStyles.vue';

declare const rootProps: never;

const i18n = createAgonI18n(rootProps['culture']);

createApp(PrintWithStyles, rootProps).use(i18n).mount('#app');
